import { render, staticRenderFns } from "./StockDetailDialog.vue?vue&type=template&id=396c0c56&scoped=true"
import script from "./StockDetailDialog.vue?vue&type=script&lang=js"
export * from "./StockDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c0c56",
  null
  
)

export default component.exports